import script from "./CustomToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomToggle.vue?vue&type=script&setup=true&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"
import "./CustomToggle.vue?vue&type=style&index=1&id=796ecf92&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796ecf92"]])

export default __exports__